var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-container"},[_c('div',{staticClass:"dashboard-chart"},[_c('div',{staticClass:"flex flex-col justify-between h-full w-full xs:flex-row"})])])
}]

export { render, staticRenderFns }